export var FlowsitePlanTypes;
(function (FlowsitePlanTypes) {
    FlowsitePlanTypes["FreeTrial"] = "Free Trial";
    FlowsitePlanTypes["Freemium"] = "Freemium";
    FlowsitePlanTypes["Standard"] = "Standard";
    FlowsitePlanTypes["Pro"] = "Pro";
    FlowsitePlanTypes["Enterprise"] = "Enterprise";
    FlowsitePlanTypes["Legacy"] = "Legacy";
})(FlowsitePlanTypes || (FlowsitePlanTypes = {}));
